import { render, staticRenderFns } from "./EconomiaDesabilitada.vue?vue&type=template&id=26f52896"
import script from "./EconomiaDesabilitada.vue?vue&type=script&lang=js"
export * from "./EconomiaDesabilitada.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports